import { useEffect, useRef, useState } from "react";

// Editorial cursor: a thin ring that lerps toward the pointer and expands over interactive targets.
export const CustomCursor = () => {
  const ringRef = useRef(null);
  const dotRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduced) return;
    setEnabled(true);
    document.documentElement.classList.add("has-custom-cursor");

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ring = { x: pos.x, y: pos.y };
    let raf = 0;

    const onMove = (e) => {
      pos.x = e.clientX;
      pos.y = e.clientY;
      if (dotRef.current) dotRef.current.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
      const t = e.target;
      const interactive = t.closest && t.closest("a, button, [role=button], input, [data-cursor=hover]");
      if (ringRef.current) ringRef.current.dataset.active = interactive ? "1" : "0";
    };
    const loop = () => {
      ring.x += (pos.x - ring.x) * 0.18;
      ring.y += (pos.y - ring.y) * 0.18;
      if (ringRef.current) ringRef.current.style.transform = `translate(${ring.x}px, ${ring.y}px)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
      document.documentElement.classList.remove("has-custom-cursor");
    };
  }, []);

  if (!enabled) return null;
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[300] hidden lg:block">
      <div
        ref={ringRef}
        data-active="0"
        className="fixed -left-4 -top-4 h-8 w-8 rounded-full border border-[hsl(var(--primary))] transition-[width,height,opacity,background-color] duration-200 data-[active=1]:h-12 data-[active=1]:w-12 data-[active=1]:bg-[hsl(var(--primary))]/10"
        style={{ willChange: "transform" }}
      />
      <div
        ref={dotRef}
        className="fixed -left-[3px] -top-[3px] h-1.5 w-1.5 rounded-full bg-[hsl(var(--primary))]"
        style={{ willChange: "transform" }}
      />
    </div>
  );
};
